<template>
  <v-layout 
    short-control-toolbar 
    hvf-toolbar 
    align-center 
    class="secondary">
    <v-flex shrink eye-text mr-auto>
      <span :class="colorClass">{{leftEyeText}}</span>
    </v-flex>
    <v-flex shrink mr-2>
      <select-with-button 
        :value="exSrNo"
        @change="selectHVFExam({exSrNo: $event})"
        :items="hvfExams"
        :icon-button="true"
        item-text="dateDisplay"
        item-value="exSrNo"
        class="toolbar-select hvf-exam-select"/>
    </v-flex>
    <v-flex shrink>
      <v-btn text
      icon
      class="modal-cta"
      @click="previousHVFImage">
      <v-icon>fas fa-caret-left</v-icon>
    </v-btn>
    <index-counter :index="hvfIndex" :count="hvfImageCount" />
    <v-btn text
      icon
      class="modal-cta"
      @click="nextHVFImage">
      <v-icon>fas fa-caret-right</v-icon>
    </v-btn>
    </v-flex>
    <od-os-ou-buttons class="mr-2" :eye="hvfEye" @selectEye="selectHVFEye" />
    <v-flex shrink>
      <image-button 
        btnClass="modal-cta" 
        title="Print Visual Fields"
        :image="coloredAssetUrls.print" 
        @click="print"/>
    </v-flex>
    <v-flex shrink>
      <v-btn text @click="openHVFMultiview">
        <v-avatar size="30" class="mr-1">
          <img :src="require('../../../assets/' + coloredAssetUrls.multiview)">
        </v-avatar>Multiview
      </v-btn>
    </v-flex>
    <v-flex shrink eye-text ml-auto>
      <span :class="colorClass">{{rightEyeText}}</span>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { EyeTypes } from "../../../config/config";
import selectWithButton from "../../controls/SelectWithButton";
import imageButton from "../../controls/ImageButton";
import indexCounter from "../IndexCounter";
import odOsOuButtons from "../controls/OdOsOuButtons";

export default {
  name: "hvfSingleExamToolbar",
  components: {selectWithButton, imageButton, indexCounter, odOsOuButtons},
  computed: {
    ...mapGetters([
      "hvfExams", 
      "exSrNo", 
      "hvfEye", 
      "hvfIndex", 
      "hvfImageCount",
       "hvfODImage", 
      "hvfOSImage", 
      "ptSrNo", 
      "hvfOrder"]),
    eyeOnLeft(){
      return this.hvfOrder ? "OS" : "OD";
    },
    eyeOnRight(){
      return this.hvfOrder ? "OD" : "OS";
    },
    leftEyeText(){
      if (this.isOS) return "OS";
      if (this.isOD) return "OD";
      return this.eyeOnLeft;
    },
    rightEyeText(){
      if (this.isOU) return this.eyeOnRight;
      return "";
    },
    isOS(){
      return this.hvfEye === EyeTypes.OS;
    },
    isOD(){
      return this.hvfEye === EyeTypes.OD;
    },
    isOU() {
      return this.hvfEye === EyeTypes.OU;
    }
  },
  methods: {
    ...mapMutations(["selectHVFEye", "previousHVFImage", "nextHVFImage"]),
    ...mapActions(["selectHVFExam", "openHVFMultiview", "openPrintPreview"]),
    print(){
      let images = [];
      if (this.isOD || this.isOU)
        images.push(this.hvfODImage);
      if (this.isOS || this.isOU)
        images.push(this.hvfOSImage);
      this.openPrintPreview(images);
    }
  }
}
</script>